<template>
  <div>
    <h1>Volunteer - Add - {{ location.name }} on {{ location.dateCreated }}</h1>

    <b-form-group
      horizontal
      label="Name:"
      label-size="lg"
      label-for="txtVolunteerName"
    >
      <b-form-input type="text" v-model="volunteer.name"></b-form-input>
    </b-form-group>

    <div>
      <b-button
        size="lg"
        :to="{ name: 'volunteers', params: { id: $route.params.id } }"
        >Cancel</b-button
      >&nbsp;
      <b-button size="lg" @click="submit">Save</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "addVolunteer",
  data: () => ({
    location: {},
    volunteer: { name: "", pinCode: null }
  }),
  methods: {
    loadLocation(id) {
      this.axios
        .get(process.env.VUE_APP_API_URL + "locations/" + id)
        .then(response => (this.location = response.data))
        .catch(error => console.log(error));
    },
    submit() {
      console.log(this.volunteer);
      this.axios
        .post(
          process.env.VUE_APP_API_URL + "volunteers/" + this.$route.params.id,
          {
            name: this.volunteer.name
          }
        )
        .then(res =>
          this.$router.push({
            name: "volunteerCode",
            params: {
              volId: res.data.id,
              locId: res.data.surveys[0].locationId
            }
          })
        )
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.loadLocation(this.$route.params.id);
  }
};
</script>
